<script setup>
const { id } = defineProps({
    id: String,
});
const image = defineModel({
    default: null,
});

import { useImageUpload } from '@utils';

const { uploadImageHandler } = useImageUpload();
const link = 'https://proctoring-api.univora.uz/services/platon-core/uploads/files/';

const uploadImage = async (event) => {
    image.value = await uploadImageHandler(event, 'image');
};
</script>

<template>
    <label class="upload-wrapper">
        <img v-if="image" :src="link + image" />
        <label v-else :for="'file' + id" class="upload-photo">
            <i class="pi pi-image"></i>
        </label>
        <input @change="uploadImage" type="file" :id="'file' + id" class="hidden" accept=".png, .jpg, .jpeg" />
    </label>
</template>

<style scoped>
.upload-wrapper {
    @apply w-20 h-20 min-w-20 flex items-center justify-center cursor-pointer;
}
.upload-wrapper img {
    @apply w-full h-full object-cover rounded-lg;
}
.upload-photo {
    @apply w-full h-full flex items-center justify-center cursor-pointer border-2 border-dashed   border-gray-400 rounded-lg;
}
.upload-photo i {
    @apply text-2xl text-gray-400;
}
</style>
